import React from 'react';

import { Button, Title, Detail } from './styles';

type Props = {
  title: string;
  detail: string;
  isSelected: boolean;
  onClick: () => void;
};

const ChoiceButton = ({ title, detail, isSelected, onClick }: Props) => (
  <Button isSelected={isSelected} onClick={onClick}>
    <Title>{title}</Title>
    <Detail>{detail}</Detail>
  </Button>
);

export default ChoiceButton;
